import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Text,
  Spacer,
  Alert,
  Stack
} from '@efast_public/fjd-component-library';
import { RouteKey } from '../AppRoutes';

export function ResetPasswordSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      style={{
        maxWidth: '90%',
        height: '100%',
        margin: '0 auto',
        padding: '40px 20px'
      }}
    >
      <Stack direction="column" spacing="l">
        <Stack direction="column" spacing="m">
          <Text size="xxl" strong style={{ marginBottom: '8px' }}>
            {t('ResetPasswordSuccessPage.title')}
          </Text>
          <Text strong size="m">
            {t('ResetPasswordSuccessPage.subtitle')}
          </Text>
        </Stack>

        <Spacer size="l" />

        <Alert
          variant="warning"
          message={t('ResetPasswordSuccessPage.alertTitle')}
        />

        <Stack direction="column" spacing="m">
          <Text size="m" strong>
            {t('ResetPasswordSuccessPage.dependencyTitle')}
          </Text>
          <Text size="m">
            {t('ResetPasswordSuccessPage.dependencyDescription')}
          </Text>
          <ol style={{ marginLeft: '20px' }}>
            <li>
              <Text size="m">{t('ResetPasswordSuccessPage.option1')}</Text>
            </li>
            <li>
              <Text size="m">{t('ResetPasswordSuccessPage.option2')}</Text>
            </li>
          </ol>

          <Text size="m">{t('ResetPasswordSuccessPage.loginInfo')}</Text>
          <Button
            variant="primary-text"
            beforeIcon="arrow-right"
            onClick={() => navigate(RouteKey.LOGIN)}
            style={{ alignSelf: 'flex-start' }}
          >
            {t('ResetPasswordSuccessPage.loginLink')}
          </Button>
        </Stack>

        <Spacer size="l" />

        <Stack direction="column" spacing="m">
          <Text size="m" strong>
            {t('ResetPasswordSuccessPage.emailNotFoundTitle')}
          </Text>
          <Text size="m">
            {t('ResetPasswordSuccessPage.emailNotFoundDescription')}
          </Text>
          <ul style={{ marginLeft: '20px' }}>
            <li>
              <Text size="m">{t('ResetPasswordSuccessPage.checkSpam')}</Text>
            </li>
            <li>
              <Text size="m">{t('ResetPasswordSuccessPage.waitAndCheck')}</Text>
            </li>
            <li>
              <Text size="m">{t('ResetPasswordSuccessPage.retryReset')}</Text>
            </li>
          </ul>
          <div>
            <Button
              variant="primary-text"
              beforeIcon="arrow-right"
              onClick={() => navigate(RouteKey.RESET_PASSWORD)}
            >
              {t('ResetPasswordSuccessPage.retryLink')}
            </Button>
          </div>
        </Stack>
      </Stack>
    </div>
  );
}
